// ldp 模板 mock 数据
module.exports = {
    // 是否预览模式
    online: true,
    id: 100,
    title: '页面标题',
    global: {
        pubArea: 'dpub',
        // pubSubArea: 'Japan',
        pubSubArea: '',
        // pageTransitionType: 'lang',
        pageTransitionType: '',

        // 分享
        canShare: true,
        share: {
            title: '分享标题',
            content: '分享内容，分享内容',
            thumbUrl: 'https://img-hxy021.didistatic.com/static/ghoneycomb/shareLogoP',
        },

        nextUrls: {
            aaa: {
                shortLink: 'https://baidu.com/',
            },
            bbb: {
                shortLink: 'https://google.com/?dchn=bb',
            },
        },
        code: {
            css: 'body { color: #333; }',
            js: 'console.log("自定义代码")',
        },
    },
    businessData: {
        comment: {
            bizType: 6,
            entityType: 7,
            groupId: 'apEU/l6uL/eFCyzWI+YjWw==',
            immediatelyShowComment: false,
            thumbUpGroupId: 'JVzNdGpjB+pYigbcKqgRbQ==',
            showArea: false,
            apiHost: 'https://lambda.xiaojukeji.com',
        },
    },
    scenes: {
        eventTable: {
            xxx: {
                action: 'location',
                eventName: 'click',
                refId: '2',
                targetUrl: 'https://163.com/',
                target: 'aaa', // global.nextUrls 中的某个 key
            },
            yyy: {
                action: 'location',
                eventName: 'click',
                refId: '4',
                target: 'bbb', // global.nextUrls 中的某个 key
            },
            zzz: {
                action: 'invokeShare',
                eventName: 'click',
                refId: 'yy-6',
            },
            // 'aaa': {
            //     action: 'download',
            //     actionName: '下载文件',
            //     eventName: 'click',
            //     name: '点击',
            //     refId: '3',
            //     omegaTrack: 'download_omegaTrack', // 统计标识
            //     downloadUrl: 'https://s.didi.cn/jmux?suffix=.zip' // 文件链接
            // }
            // 'aaa': {
            //     action: 'dialog',
            //     actionName: '弹窗',
            //     eventName: 'click',
            //     name: '点击',
            //     refId: '3',
            //     refedId: 'widget-_4d9Gu06Q',
            //     omegaTrack: 'dialog_omegaTrack' // 统计标识
            // }
            aaa: {
                action: 'anchor',
                actionName: '页面位置',
                eventName: 'click',
                name: '点击',
                omegaTrack: 'anchor_omegaTrack',
                refId: '3',
                refedId: 'yy-6', // 锚点组件 id
            },
        },
        style: {
            // backgroundColor: '#f1f1f1',
            paddingTop: '1px', // 防止第一个元素设置了 margin-top 而溢出
            minHeight: 603, // 预期会被 dpub-render 过滤掉
        },
        layers: [
            // 标题 + 副标题
            {
                type: 'DpubGroup',
                id: '1',
                style: { marginTop: '50px', height: 'auto' },
                children: [
                    // 标题
                    {
                        type: 'DpubText',
                        id: '2',
                        props: {
                            text: '这是一行标题',
                            fontSize: 40,
                            lineHeight: 60,
                        },
                    },
                    // 副标题
                    {
                        type: 'DpubText',
                        id: '3',
                        props: {
                            text: '这是一行副标题（锚点）',
                            color: 'red',
                            lineHeight: 40,
                        },
                    },
                    // 富文本
                    {
                        type: 'DpubText',
                        id: '3-1',
                        props: {
                            text: '富文本<a href="https://dpub.didi.cn/">一个链接</a> test',
                            color: 'red',
                            lineHeight: 40,
                        },
                    },
                ],
            },
            // 内容图
            {
                type: 'DpubImage',
                id: '4',
                style: { marginTop: 50 },
                props: {
                    url: 'https://dpubstatic.udache.com/static/dpubimg/ce7447a5-e6f8-425e-9bea-7797d7b55d1a.jpg',
                    width: '100%',
                },
            },
            // 隐藏的图片
            {
                id: '4-1',
                type: 'DpubImage',
                style: { marginTop: 50, width: '100%' },
                props: {
                    url: 'https://dpubstatic.udache.com/static/dpubimg/bb0c82c5-abd8-41e0-84ea-aa5e3e80b4d2.jpg',
                    width: '100%',
                },
                editorStatus: {
                    show: false, // 表示该组件隐藏
                },
            },
            {
                id: 'yy-6',
                type: 'DpubImage',
                style: { marginTop: 50, width: '100%' },
                props: {
                    url: 'https://dpubstatic.udache.com/static/dpubimg/bb0c82c5-abd8-41e0-84ea-aa5e3e80b4d2.jpg',
                    width: '100%',
                },
            },
            // logo
            {
                id: 'yy-5',
                type: 'DpubLogo',
                style: { backgroundColor: '' },
                props: {
                    backgroundColor: 'gray',
                    url: '//dpubstatic.udache.com/static/dpubimg/8cb581e2-7f5d-4352-b323-e9ba3644b88c.png',
                    width: '100%',
                    height: 'auto',
                },
            },

            // 弹框组件
            {
                style: {
                    position: 'absolute',
                    display: 'block',
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    opacity: 1,
                    marginTop: 0,
                    marginLeft: 0,
                    marginRight: 0,
                    marginBottom: 0,
                    rotate: 0,
                    scale: 1,
                    translateX: 0,
                    translateY: 0,
                    backgroundColor: 'transparent',
                    border: '0px solid #000000',
                    boxShadow: '#000000 0px 0px 0px 0px',
                    transform: 'translate(0, 0), scale(1), rotate(0)',
                    zIndex: 1000,
                },
                editorStatus: {
                    show: true,
                    active: false,
                    isLock: false,
                },
                id: 'widget-_4d9Gu06Q',
                id_name: '',
                type: 'DpubDialog',
                key: 'DpubDialog',
                name: '弹框',
                label: '',
                effectList: [],
                props: {
                    title: '弹框标题',
                    content: '弹框内容',
                    submitText: '确认',
                    cancelText: '取消',
                },
            },
            {
                style: {
                    position: 'relative',
                    display: 'block',
                    left: 0,
                    top: 0,
                    right: 'unset',
                    bottom: 'unset',
                    opacity: 1,
                    marginTop: 40,
                    marginLeft: 25,
                    marginRight: 25,
                    marginBottom: 0,
                    rotate: 0,
                    scale: 1,
                    translateX: 0,
                    translateY: 0,
                    backgroundColor: '',
                    border: '0px solid #000000',
                    boxShadow: '#000000 0px 0px 0px 0px',
                    transform: 'translate(0, 0) scale(1) rotate(0deg)',
                    color: '#333',
                    fontFamily: '"PingFang SC", STHeitiSC-Light, Helvetica-Light, arial, sans-serif',
                },
                editorStatus: {
                    show: true,
                    active: false,
                    isLock: false,
                },
                id: 'widget-n4p51KuVw',
                id_name: '',
                type: 'DpubGroup',
                key: 'DpubHeadTitleGroup',
                name: '一级标题组',
                label: '',
                effectList: [],
                props: {},
                children: [
                    {
                        style: {
                            position: 'relative',
                            display: 'block',
                            left: 0,
                            top: 0,
                            right: 'unset',
                            bottom: 'unset',
                            opacity: 1,
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0,
                            marginBottom: 0,
                            rotate: 0,
                            scale: 1,
                            translateX: 0,
                            translateY: 0,
                            backgroundColor: '',
                            border: '0px solid #000000',
                            boxShadow: '#000000 0px 0px 0px 0px',
                            transform: 'translate(0, 0), scale(1), rotate(0)',
                            color: '#333',
                            fontFamily: '"PingFang SC", STHeitiSC-Light, Helvetica-Light, arial, sans-serif',
                        },
                        editorStatus: {
                            show: true,
                            active: false,
                            isLock: false,
                        },
                        id: 'widget-UjbLA5Cckr',
                        id_name: '',
                        type: 'DpubHeadTitle',
                        key: 'DpubHeadTitle',
                        name: '一级标题',
                        label: '',
                        effectList: [],
                        props: {
                            text: '我是一行一级标题',
                            color: '#333333',
                            fontFamily: 'inherit',
                            fontSize: 30,
                            fontStyle: 'normal',
                            fontWeight: 600,
                            lineHeight: 36,
                            textAlign: 'left',
                            textDecoration: 'none',
                            canEdit: false,
                        },
                        children: [],
                    },
                    {
                        style: {
                            position: 'relative',
                            display: 'block',
                            left: 0,
                            top: 0,
                            right: 'unset',
                            bottom: 'unset',
                            opacity: 1,
                            marginTop: 20,
                            marginLeft: 0,
                            marginRight: 0,
                            marginBottom: 0,
                            rotate: 0,
                            scale: 1,
                            translateX: 0,
                            translateY: 0,
                            backgroundColor: '',
                            border: '0px solid #000000',
                            boxShadow: '#000000 0px 0px 0px 0px',
                            transform: 'translate(0, 0), scale(1), rotate(0)',
                            color: '#333',
                            fontFamily: '"PingFang SC", STHeitiSC-Light, Helvetica-Light, arial, sans-serif',
                        },
                        editorStatus: {
                            show: true,
                            active: false,
                            isLock: false,
                        },
                        id: 'widget-suCiLtUeR5',
                        id_name: '',
                        type: 'DpubThirdTitle',
                        key: 'DpubThirdTitle',
                        name: '三级标题',
                        label: '',
                        effectList: [],
                        props: {
                            text: '我是一行三级标题',
                            color: '#333333',
                            fontFamily: 'inherit',
                            fontSize: 16,
                            fontStyle: 'normal',
                            fontWeight: 400,
                            lineHeight: 22.5,
                            textAlign: 'left',
                            textDecoration: 'none',
                        },
                        children: [],
                    },
                ],
            },
        ], // layers end
    }, // scenes end
};
